import { Box, Chip } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ReusableTable from '../../common/table/CommonTable';
import { fetchSecurityOfficers } from '../../redux/secuityOfficer/securityAction';

const DoctorSGList = () => {
   const navigate = useNavigate();
   const dispatch = useDispatch();
 
   useEffect(() => {
     dispatch(fetchSecurityOfficers());
   }, [dispatch]);
 
   const securityOfficerState = useSelector((state) => state?.securityOfficer?.fetchSecurityOfficers || {});
 const securityOfficerList = securityOfficerState?.data?.data?.data || [];
 
   const columns = [
     { id: 'id', label: 'Guard ID', sortable: true },
     { id: 'security_gaurd_name', label: 'Name', sortable: true },
     { id: 'email', label: 'Email', sortable: true },
     { id: 'phone_number', label: 'Phone Number', sortable: true },
     { 
       id: 'status', 
       label: 'Status', 
       sortable: true,
       render: (value) => (
         <Chip label={value === 1 ? 'Active' : 'Inactive'} color={value === 1 ? 'success' : 'warning'} />
       )
     }
   ];


  return (
    <Box>
      <ReusableTable
        title="Security Officers"
        columns={columns}
        data={securityOfficerList}
        isLoading={!securityOfficerList.length}
        headerColor="#000" 
        rowColor="#ffffff" 
        alternateRowColor="#f5f5f5" 
        withPagination={true}
        withActions={false}
        rowsPerPage={10}
        showDownloadOption={true} 
      />
    </Box>
  );
};

export default DoctorSGList;
